'use es6';
/*
 * Similar to Flashes in Rails
 *
 * http://api.rubyonrails.org/classes/ActionDispatch/Flash.html
 */

import { FLASH, FLASH_REMOVE } from 'DesignData/actions/ActionTypes';
/**
 * Dispatches a message to be populated in the Flash store,
 * and at the end of the callstack dispatches another message to clear it.
 *
 * @see {@link http://api.rubyonrails.org/classes/ActionDispatch/Flash.html|Ruby on Rails Flash Docs}
 *
 * @param {DesignData/enums/FlashKeys}  flashKey
 * @param {Any}                         message
 * @return {Function}
 */

export function flash(flashKey, message) {
  const {
    add,
    remove
  } = flash;
  return dispatch => {
    dispatch(add(flashKey, message));
    setTimeout(() => {
      dispatch(remove(flashKey));
    }, 0);
  };
}

flash.add = function add(flashKey, message) {
  return {
    type: FLASH,
    flashKey,
    message
  };
};

flash.remove = function remove(flashKey) {
  return {
    type: FLASH_REMOVE,
    flashKey
  };
};